import "./styles.css";

import { useEffect, useRef, useState } from "react";

function ShowMoreText({ children, lines = 4 }) {
  const [showExpandButton, setShowExpandButton] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    const computedStyle = getComputedStyle(textarea);
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const collapsedHeight = lineHeight * lines;

    // اول height را آزاد می‌کنیم تا scrollHeight واقعی را بگیریم
    textarea.style.height = "auto";
    const fullHeight = textarea.scrollHeight;

    // آیا متن بیشتر از تعداد خطوط مجاز است؟
    setShowExpandButton(fullHeight > collapsedHeight + 1);

    // تنظیم ارتفاع نهایی
    if (expanded) {
      textarea.style.height = fullHeight + "px";
    } else {
      textarea.style.height = collapsedHeight + "px";
    }
  }, [expanded, children, lines]);

  return (
    <div className="flex flex-col w-full">
      <textarea ref={textareaRef} readOnly value={children} className="showmore-textarea bg-transparent" />

      {showExpandButton && (
        <button className="text-xs text-blue-700 w-fit mr-auto" onClick={() => setExpanded(!expanded)}>
          {expanded ? "نمایش کمتر" : "نمایش بیشتر"}
        </button>
      )}
    </div>
  );
}

export default ShowMoreText;
